//Se tiene que eliminar este file, luego de cargar las acciones en sus propios archivos

import ActionTypeCliente from "./ActionTypeCliente";

export class SetCobranzaModoCobro extends ActionTypeCliente {}
export class SetCobranzaTipoComprobante extends ActionTypeCliente {}
export class SetCobranzaCicloFact extends ActionTypeCliente {}

export class SetPersonaContactoValorListaNombres extends ActionTypeCliente {}
export class SetPersonaContactoValorListaNombresOperaciones extends ActionTypeCliente {}
export class SetPersonaContactoListaNombres extends ActionTypeCliente {}
export class SetPersonaContactoAtributosNombre extends ActionTypeCliente {}
export class SetPersonaContactoAtributosRol extends ActionTypeCliente {}
export class SetPersonaContactoAtributosTelcel1 extends ActionTypeCliente {}
export class SetPersonaContactoAtributosTelcel2 extends ActionTypeCliente {}
export class SetPersonaContactoAtributosTelfijo extends ActionTypeCliente {}
export class SetPersonaContactoAtributosEmail extends ActionTypeCliente {}

export class SetPersonasContactoActNombre extends ActionTypeCliente {}
export class SetPersonasContactoActRol extends ActionTypeCliente {}
export class SetPersonasContactoActTelcel1 extends ActionTypeCliente {}
export class SetPersonasContactoActTelcel2 extends ActionTypeCliente {}
export class SetPersonasContactoActTelfijo extends ActionTypeCliente {}
export class SetPersonasContactoActEmail extends ActionTypeCliente {}

export class EliminarContactoAct extends ActionTypeCliente {}

// export class GuardarClienteAFacturar extends ActionTypeFact {}
// export class CargarDataRegistradaDeClienteAFacturar extends ActionTypeFact {}
// export class CargarArrayErroresEnClienteAFacturar extends ActionTypeFact {}
// export class CargarErrorComunicEnClienteAFacturar extends ActionTypeFact {}
